import { Fragment, ReactElement } from 'react';
import PersonSearchDeathNonResidentNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-death-non-resident/edit-person-search';

const PersonSearchDeathNonResidentNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonSearchDeathNonResidentNotificationCivilStatusShared />
    </Fragment>
  );
};

PersonSearchDeathNonResidentNotificationCivilStatusPage.displayName =
  'Research Death Non Resident Notifications Page component';

export default PersonSearchDeathNonResidentNotificationCivilStatusPage;
